import React from 'react';
const modules = [{
  title: 'Running Foundations™',
  description: 'Master biomechanics, training principles, energy systems, pacing, recovery, injury prevention, and the fundamentals every coach needs.'
}, {
  title: 'Running Drill Library™',
  description: 'A complete database of technique drills, mobility exercises, strength movements, injury prevention exercises, and performance development tools.'
}, {
  title: 'Session Builder System™',
  description: 'Create professional running sessions in minutes using proven templates, workout structures, programming formulas, and coaching frameworks.'
}, {
  title: 'Ready-To-Use Running Workouts™',
  description: '50+ ready-to-use workouts for beginners, 5K, 10K, Half Marathon, Marathon, fitness, and endurance athletes.'
}, {
  title: 'Running Program Design™',
  description: 'Build professional 4-week, 8-week, and 12-week programs using periodization systems, race preparation frameworks, and progression models.'
}, {
  title: 'Coaching Tools & Athlete Management™',
  description: 'Assessment systems, athlete tracking forms, coaching checklists, progress monitoring tools, and professional coaching resources.'
}];
export function ModulesSection() {
  return <section className="py-12 px-4 sm:px-6 bg-brand-navy text-white" data-id="element-112">
      <div className="text-center mb-10" data-id="element-113">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-white mb-3 uppercase leading-tight" data-id="element-114">
          THE SOLUTION YOU'VE BEEN LOOKING FOR — A COMPLETE 6-IN-1 SYSTEM
        </h2>
        <p className="text-sm sm:text-base font-bold text-brand-orange mb-4 uppercase tracking-wide" data-id="element-115">
          6 Professional Modules In 1 Complete Coaching System
        </p>
        <div className="inline-block bg-brand-teal text-white px-4 py-2 rounded mb-4 shadow-lg border border-brand-teal/50" data-id="element-116">
          <p className="font-bold text-sm tracking-wide uppercase" data-id="element-117">
            🏃 RUNNING COACH READY™ — 6-in-1 Complete Box Set
          </p>
        </div>
        <p className="text-sm sm:text-base text-white/90 leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-118">
          RUNNING COACH READY™ is much more than a collection of workouts.
          <br data-id="element-119" />
          <br data-id="element-120" />
          It is a complete coaching operating system designed to help you plan
          faster, coach better, and deliver professional running programs with
          confidence.
        </p>
      </div>

      <div className="flex flex-col gap-4 max-w-3xl mx-auto" data-id="element-121">
        {modules.map((module, i) => <div key={i} className="bg-white text-brand-ink p-5 rounded-lg flex gap-4 items-start shadow-xl border-b-4 border-brand-teal" data-id="element-122">
            <div className="text-white shrink-0 bg-brand-green w-8 h-8 flex items-center justify-center rounded-full font-black text-sm mt-0.5 shadow-md" data-id="element-123">
              ✓
            </div>
            <div data-id="element-124">
              <h3 className="text-base font-bold leading-tight mb-1.5 text-brand-navy uppercase" data-id="element-125">
                {module.title}
              </h3>
              <p className="text-brand-ink/80 text-sm leading-relaxed" data-id="element-126">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}